import React, { useState, useEffect } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { toast } from "react-toastify";
import { constants, FEEDBACK_STATUSES } from "../../utils/constants";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import { useHistory } from 'react-router-dom';
import { GetFeedbackById, UpdateFeedbackStatus } from '../../services/feedback.service';
import { GetUserById } from '../../services/users.service';
import { FadeLoader } from 'react-spinners';

const initialData = {
    id: '',
    userId: '',
    feedback: '',
    status: FEEDBACK_STATUSES.UNREAD,
    updatedAt: '',
    user: {
        name: '',
        email: '',
    }
}

function ViewFeedback(props) {
    const history = useHistory();
    const [data, setData] = useState(initialData);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let id = props.match.params.id;
        getFeedback(id);
    }, []);

    const getFeedback = async (id) => {
        setLoading(true);

        try {
            const result = await GetFeedbackById(id);
            if (result.status) {
                if (result.data) {
                    let dt = result.data;
                    setData({
                        id: dt._id,
                        userId: dt.userId,
                        feedback: dt.feedback,
                        status: dt.status,
                        updatedAt: dt.updatedAt,
                        user: { ...initialData.user } // Initialize with empty user data
                    });
                    // Fetch user details
                    getUserDetails(dt.userId);
                }
            } else {
                toast.error(result.message);
            }
        } catch (error) {
            handleError(error);
        }

    }

    const getUserDetails = async (userId) => {
        try {
            const result = await GetUserById(userId);
            if (result.status) {
                setData(prevData => ({
                    ...prevData,
                    user: {
                        name: result.data.fullName || '',
                        email: result.data.email || '',
                    }
                }));
            } else {
                toast.error("Failed to fetch user details");
            }
        } catch (error) {
            handleError(error);
        }
        setLoading(false);

    }

    const handleStatusChange = async (e) => {
        const newStatus = Number(e.target.value); // Directly extract the number value
        try {
            const result = await UpdateFeedbackStatus(data.id, { status: newStatus });
            if (result.status) {
                setData(prevData => ({
                    ...prevData,
                    status: newStatus // Update status correctly in state
                }));
                toast.success("Feedback status updated successfully");
            } else {
                toast.error(result.message);
            }
        } catch (error) {
            handleError(error);
        }
    }
    

    const handleError = (error) => {
        if (error.response && error.response.status === 401) {
            EmptyLocalStorage();
            history.push('/');
        } else {
            toast.error(error.response?.data?.message || "An error occurred");
        }
    }

    if (loading) {
        return (
            <div className='spin-loader d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                <FadeLoader color={'#41D2D2'} height={10} />
            </div>
        );
    }

    return (
        <div className={"feedback"}>
            <h3 className="page-heading">Feedback</h3>
            <hr />
            <div className={"feedback"}>
                <div className={"feedbackCardHeader"}>
                    <Row>
                        <Col xs={12} sm={8} md={7} lg={6} xl={7}>
                            <div className={"feedbackDetails"}>
                                <p><b>User Name: </b>{data.user.name}</p>
                                <p><b>User Email: </b>{data.user.email}</p>
                                <p><b>Feedback: </b>{data.feedback}</p>
                                <p><b>Last Updated: </b>{new Date(data.updatedAt).toLocaleString([], {  year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                            </div>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label><b>Status:</b></Form.Label>
                                <Form.Select
                                    value={data.status}
                                    onChange={handleStatusChange}
                                >
                                    <option value={FEEDBACK_STATUSES.UNREAD}>Unread</option>
                                    <option value={FEEDBACK_STATUSES.ADDRESSED}>Addressed</option>
                                    <option value={FEEDBACK_STATUSES.SAVED_LATER}>Saved for Later</option>
                                    <option value={FEEDBACK_STATUSES.IGNORE}>Ignored</option>
                                </Form.Select>
                            </Form.Group>

                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default ViewFeedback;